import { Icon } from '@/components/generic';
import { cn } from '@/lib/utils';
import axios, { type AxiosError } from 'axios';

export const Error = (
  {
    error,
    message,
    className,
  }: {
    error?: boolean | Error | null | string | AxiosError;
    message?: string;
    className?: string;
  } = {
    error: false,
    message: '',
    className: '',
  },
) => {
  if (!error) return null;

  if (axios.isAxiosError(error)) {
    message = error.response?.data?.msg || message || 'An error occurred.';
  }

  return (
    <div
      className={cn(
        'flex gap-2 w-full mb-2 p-2 rounded-xl  outline-none  items-center justify-start bg-primary-03/10 border border-primary-03/80',
        className,
      )}
    >
      <Icon name='info' className='w-5 h-5 shrink-0 fill-primary-03/80 ' />

      <span className='text-body-2 text-primary-03/80 font-bold leading-relaxed'>
        {message}
      </span>
    </div>
  );
};
